// extracted by mini-css-extract-plugin
export var statItem = "_jj-1";
export var statsRow = "_jj-0";